<template>
  <div>
    <v-dialog v-model="dialog" persistent scrollable width="900">
      <v-card :disabled="btnLoading" :loading="btnLoading">

        <v-card-title>
          {{ titleDialog }}
          <v-spacer/>
          <v-icon @click="close" class="cursor-pointer">mdi-close</v-icon>
        </v-card-title>

        <v-divider/>

        <v-card-text class="pa-8">

          <v-row>
            <v-col cols="12">
              <v-checkbox v-model="form.is_available" hide-details color="success" label="Disponible ?"/>
            </v-col>
            <v-col cols="6">
              <v-text-field hide-details="auto"
                            v-model="form.name"
                            label="Nom de méthode *"
                            outlined
                            dense
                            :error-messages="errors.name"
              />

            </v-col>
            <v-col cols="6">
              <v-select hide-details="auto" :items="services"
                        item-value="id"
                        item-text="name"
                        v-model="form.service_id"
                        label="Service *"
                        outlined
                        dense
                        :error-messages="errors.service_id"
              />
            </v-col>
          </v-row>

          <v-radio-group row hide-details="auto"
                         v-model="form.retrieval_method"
                         :error-messages="errors.retrieval_method"
                         label="Méthode de récupération *"
          >
            <v-radio label="Scanner" value="scan"></v-radio>
            <v-radio label="Formulaire" value="form"></v-radio>
            <v-radio label="Scanner + Formulaire" value="both"></v-radio>
          </v-radio-group>

          <v-radio-group row
                         v-model="form.amount_retrieval"
                         :error-messages="errors.amount_retrieval"
                         label="Récupération du montant *"
          >
            <v-radio label="Via API" value="api"></v-radio>
            <v-radio label="Saisie manuelle" value="manual"></v-radio>
          </v-radio-group>

          <div v-for="(row, rowIndex) in form.field_config" :key="rowIndex" class="mb-8 pa-4 rounded-lg grey lighten-4">

            <div class="d-flex justify-space-between align-center mb-4">
              <h4 class="gifty-text">
                <v-icon left color="gifty">mdi-format-line-style</v-icon>
                Ligne {{ rowIndex + 1 }}
              </h4>
              <v-btn icon color="error" @click="removeFieldRow(rowIndex)">
                <v-icon>mdi-close-circle-outline</v-icon>
              </v-btn>
            </div>

            <v-row dense>
              <v-col cols="12" v-for="(field, fieldIndex) in row" :key="fieldIndex" class="mb-6">
                <v-card outlined>
                  <v-card-title class="d-flex justify-space-between align-center">
                    <h5 class="gifty-text d-flex align-center">
                      <v-icon color="gifty" left>mdi-form-textbox</v-icon>
                      Champ {{ fieldIndex + 1 }}
                    </h5>
                    <v-btn icon color="error" @click="removeFieldFromRow(rowIndex, fieldIndex)">
                      <v-icon>mdi-delete-outline</v-icon>
                    </v-btn>
                  </v-card-title>

                  <v-card-text>
                    <v-row dense justify="center">

                      <v-col cols="6" md="4">
                        <v-text-field :disabled="fieldIndex > 0"
                                      v-model="field.label_fr"
                                      hint="Label à afficher (FR)"
                                      persistent-hint
                                      :outlined="fieldIndex === 0"
                                      :filled="fieldIndex > 0"
                                      dense
                        />
                      </v-col>

                      <v-col cols="6" md="4">
                        <v-text-field :disabled="fieldIndex > 0"
                                      v-model="field.label_en"
                                      hint="Label à afficher (EN)"
                                      persistent-hint
                                      :outlined="fieldIndex === 0"
                                      :filled="fieldIndex > 0"
                                      dense
                        />
                      </v-col>

                      <v-col cols="6" md="4">
                        <v-text-field :disabled="fieldIndex > 0"
                                      v-model="field.label_ar"
                                      hint="Label à afficher (AR)"
                                      persistent-hint
                                      :outlined="fieldIndex === 0"
                                      :filled="fieldIndex > 0"
                                      dense
                        />
                      </v-col>


                      <v-col cols="6" md="4">
                        <v-text-field v-model="field.hint_fr"
                                      hint="Texte d'aide (hint FR)"
                                      persistent-hint
                                      outlined
                                      dense
                        />
                      </v-col>

                      <v-col cols="6" md="4">
                        <v-text-field v-model="field.hint_en"
                                      hint="Texte d'aide (hint EN)"
                                      persistent-hint
                                      outlined
                                      dense
                        />
                      </v-col>

                      <v-col cols="6" md="4">
                        <v-text-field v-model="field.hint_ar"
                                      hint="Texte d'aide (hint AR)"
                                      persistent-hint
                                      outlined
                                      dense
                        />
                      </v-col>


                      <v-col cols="6" md="4">
                        <v-text-field
                            v-model="field.key"
                            hint="Clé du champ"
                            persistent-hint
                            outlined
                            dense
                        />
                      </v-col>

                      <v-col cols="6" md="4">
                        <v-select
                            v-model="field.type"
                            :items="['text', 'number']"
                            hint="Type"
                            persistent-hint
                            outlined
                            dense
                        />
                      </v-col>
                      <v-col cols="6" md="4">
                        <v-text-field
                            v-model.number="field.flex"
                            type="number"
                            hint="Flex (colonne)"
                            persistent-hint
                            outlined
                            dense
                        />
                      </v-col>
                      <v-col cols="6" md="4">
                        <v-text-field
                            v-model.number="field.minLength"
                            type="number"
                            hint="Longueur min"
                            persistent-hint
                            outlined
                            dense
                        />
                      </v-col>
                      <v-col cols="6" md="4">
                        <v-text-field
                            v-model.number="field.maxLength"
                            type="number"
                            hint="Longueur max"
                            persistent-hint
                            outlined
                            dense
                        />
                      </v-col>
                      <v-col cols="6" md="4">
                        <v-combobox small-chips
                                    deletable-chips
                                    v-model="field.strictLengths"
                                    multiple
                                    chips
                                    clearable
                                    hint="Longueurs strictes : Ex: 15, 18, 20"
                                    outlined
                                    dense
                                    persistent-hint
                        />
                      </v-col>
                      <v-col cols="6" md="4">
                        <v-file-input hint="Image explicatif"
                                      clearable
                                      :loading="uploadLoading"
                                      @change="uploadImage($event,rowIndex,fieldIndex)"
                                      outlined
                                      dense
                                      accept="image/*"
                                      persistent-hint
                        />
                      </v-col>
                      <v-col cols="8" md="8">
                        <v-avatar rounded size="40">
                          <v-img class="grey lighten-4" :src="fileUrl + field.image"></v-img>
                        </v-avatar>
                        <v-icon color="red" v-if="field.image" @click="field.image = null">mdi-close</v-icon>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <div class="text-center">
              <v-btn small
                     dark
                     depressed
                     color="gifty"
                     @click="addFieldToRow(rowIndex)">
                <v-icon left size="18">mdi-plus</v-icon>
                Ajouter un champ
              </v-btn>
            </div>

          </div>

          <div class="text-center mt-6">
            <v-btn color="gifty" outlined @click="addFieldRow">
              <v-icon left>mdi-plus</v-icon>
              Ajouter une nouvelle ligne
            </v-btn>
          </div>


        </v-card-text>

        <v-divider/>


        <v-card-actions>
          <v-spacer/>
          <v-btn
              :loading="btnLoading"
              color="primary"
              depressed
              @click="save"
          >
            <v-icon left>mdi-content-save</v-icon>
            Enregistrer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {HTTP} from "@/http-common";

export default {
  props: ['services'],
  data() {
    return {
      dialog: false,
      fileUrl: process.env.VUE_APP_FILE_URL,
      titleDialog: "",
      uploadLoading: false,
      btnLoading: false,
      form: {
        is_available: true
      },
      errors: {},
    };
  },
  methods: {
    addFieldRow() {
      this.form.field_config.push([]);
    },
    uploadImage(file, rowIndex, fieldIndex) {
      if (file) {
        const url = "/v1/payings-bill-methods/upload-image";
        this.uploadLoading = true;
        let formData = new FormData()
        formData.append("image", file)

        HTTP.post(url, formData)
            .then((res) => {
              this.uploadLoading = false;
              this.form.field_config[rowIndex][fieldIndex].image = res.data
            })
            .catch((err) => {
              this.uploadLoading = false;
              this.$errorMessage = "Une erreur s'est produite, veuillez corriger.";
              console.error(err);
            });
      }
    },
    addFieldToRow(rowIndex) {
      this.form.field_config[rowIndex].push({
        key: null,
        label_fr: null,
        label_en: null,
        label_ar: null,
        hint_fr: null,
        hint_en: null,
        hint_ar: null,
        type: 'text',
        maxLength: null,
        minLength: null,
        strictLengths: [],
        flex: 1,
        image: null,
      });
    },
    removeFieldFromRow(rowIndex, fieldIndex) {
      this.form.field_config[rowIndex].splice(fieldIndex, 1);
    },
    removeFieldRow(rowIndex) {
      this.form.field_config.splice(rowIndex, 1);
    },
    open(item = null) {
      this.titleDialog = item ? "Modifier une méthode" : "Ajouter une méthode";
      this.dialog = true;
      this.errors = {};
      this.form = {
        id: item?.id ?? null,
        name: item?.name ?? null,
        service_id: item?.service_id ?? null,
        retrieval_method: item?.retrieval_method ?? null,
        amount_retrieval: item?.amount_retrieval ?? null,
        field_config: item?.field_config ?? [],
        is_available: item?.is_available ?? true,
      };
    },
    close() {
      this.dialog = false;
    },
    save() {
      this.errors = {};
      const url = this.form.id ? "/v1/payings-bill-methods/update" : "/v1/payings-bill-methods/store";
      this.btnLoading = true;

      HTTP.post(url, this.form)
          .then(() => {
            this.btnLoading = false;
            this.$successMessage = "Cette Config a été enregistrée avec succès.";
            this.close();
            this.$emit("refresh");
          })
          .catch((err) => {
            this.btnLoading = false;
            this.errors = err.response?.data?.errors || {};
            this.$errorMessage = "Une erreur s'est produite, veuillez corriger.";
            console.error(err);
          });
    },
  },
};
</script>
